import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";


@Component({
  selector: 'app-vehiculos-categoria',
  templateUrl: './vehiculos-categoria.component.html',
  styleUrls: ['./vehiculos-categoria.component.css']
})
export class VehiculosCategoriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}